import { useEffect, useRef, useState } from "react";
import { Checkbox, Input, Modal, Segmented, Select } from "antd";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

const { Option } = Select;

const CashMethod = ({
  cashOpen,
  setCashOpen,
  handleOk,
  handleCancel,
  cashValue,
  setCashValue,
  totalNetAmt,
  cardAmt,
  setCardAmt,
  upiAmt,
  setUpiAmt,
  onlineAmt,
  setOnlineAmt,
  cashAmt,
  setCashAmt,
  creditAmt,
  setCreditAmt,
  setSwitchCredit,
  switchCredit,
  creditCashValue,
  setCreditCashValue,
  creditCashAmt,
  setCreditCashAmt,
  creditCardAmt,
  setCreditCardAmt,
  creditUpiAmt,
  setCreditUpiAmt,
  creditOnlineAmt,
  setCreditOnlineAmt,
}) => {
  const [selectionLocked, setSelectionLocked] = useState(false);
  const [selectionCreditLocked, setSelectionCreditLocked] = useState(false);
  const cardRef = useRef(null);
  const upiRef = useRef(null);
  const onlineRef = useRef(null);
  const creditRef = useRef(null);

  const handleChange = (method) => {
    if (!selectionLocked) {
      setCashValue(method);
      setOnlineAmt(0);
      setUpiAmt(0);
      setCardAmt(0);
      setCashAmt(0);
      setCreditAmt(0);
    }
    if (method === "CARD") {
      setCardAmt(totalNetAmt);
      cardRef.current?.focus();
    }
    if (method === "UPI") {
      setUpiAmt(totalNetAmt);
      upiRef.current?.focus();
    }
    if (method === "ONLINE") {
      setOnlineAmt(totalNetAmt);
      onlineRef.current?.focus();
    }
    if (method === "CREDIT") {
      setCreditAmt(totalNetAmt);
      creditRef.current?.focus();
    }
    if (method === "CASH") {
      setCashAmt(totalNetAmt);
    }
  };

  const handleCreditChange = (method) => {
    if (!selectionCreditLocked) {
      setCreditCashValue(method);
      setCreditOnlineAmt(0);
      setCreditUpiAmt(0);
      setCreditCardAmt(0);
      setCreditCashAmt(0);
    }
    if (method === "CARD") {
      setCreditCardAmt(totalNetAmt);
      cardRef.current?.focus();
    }
    if (method === "UPI") {
      setCreditUpiAmt(totalNetAmt);
      upiRef.current?.focus();
    }
    if (method === "ONLINE") {
      setCreditOnlineAmt(totalNetAmt);
      onlineRef.current?.focus();
    }
    if (method === "CASH") {
      setCreditCashAmt(totalNetAmt);
    }
  };

  const handleModalOk = () => {
    setSelectionLocked(true);
    handleOk(); // call your parent handler if needed
  };

  const handleModalCancel = () => {
    setSelectionLocked(false);
    handleCancel(); // call your parent handler if needed
  };

  const handleCreditModalOk = () => {
    setSelectionCreditLocked(true);
    handleOk(); // call your parent handler if needed
  };
  const handleCreditModalCancel = () => {
    setSelectionCreditLocked(false);
    handleCancel(); // call your parent handler if needed
  };

  useEffect(() => {
    const amount = totalNetAmt - cardAmt - upiAmt - onlineAmt - creditAmt;
    setCashAmt(amount);
  }, [totalNetAmt, cardAmt, upiAmt, onlineAmt, creditAmt]);

  const handleLimitedInput = (e, setFunc) => {
    const value = e.target.value.replace(/\D/g, "");

    if (Number(value) > Number(totalNetAmt)) {
      return; // ❌ Stop typing more than total amount
    }

    setFunc(Number(value));
  };

  return (
    <Modal
      className="pm-modal"
      title={<div className="pm-title">Payment Mode</div>}
      open={cashOpen}
      onOk={handleModalCancel || handleCreditModalCancel}
      onCancel={handleModalCancel || handleCreditModalCancel}
      closable={false}
      okText="OK"
      cancelText="Cancel"
      maskStyle={{
        backdropFilter: "blur(8px)", // <- this applies the blur effect
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional: tint the background a little
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .pm-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .pm-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .pm-modal .ant-modal-body{padding:12px 14px 4px;background:#eef1f8}
        .pm-modal .ant-modal-footer{margin:0;padding:10px 14px 14px;background:#eef1f8;display:flex;gap:10px}
        .pm-modal .ant-modal-footer .ant-btn{flex:1;height:42px;border-radius:12px;font-weight:800}
        .pm-modal .ant-modal-footer .ant-btn-primary{background:linear-gradient(135deg,#162566,#2a3c8f);border:0}

        .pm-title{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .pm-total{display:flex;align-items:center;justify-content:space-between;background:linear-gradient(135deg,#1f8f6a,#52bd91);color:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 4px 12px rgba(31,143,106,.3)}
        .pm-total-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.9}
        .pm-total-v{font-size:22px;font-weight:800}
        .pm-mode{background:rgba(255,255,255,.22);border-radius:10px;padding:3px 10px;font-size:12px;font-weight:800}

        .pm-list{display:flex;flex-direction:column;gap:8px;margin-top:10px;max-height:60vh;overflow-y:auto;padding:2px}
        .pm-row{display:flex;align-items:center;gap:10px;background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 10px;cursor:pointer;transition:all .15s;box-shadow:0 1px 4px rgba(0,0,0,.05)}
        .pm-row.active{border-color:#52bd91;background:linear-gradient(135deg,#f2fcf7,#e3f7ee);box-shadow:0 3px 10px rgba(82,189,145,.25)}
        .pm-ico{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
        .pm-label{flex:1;font-weight:800;font-size:13px;color:#162566}
        .pm-val{display:flex;justify-content:flex-end}
        .pm-input{width:120px;height:36px;border-radius:10px!important;font-size:16px;font-weight:800;text-align:right;color:#162566}
        .pm-input-wide{width:100%;height:36px;border-radius:10px!important;font-size:15px}
        .pm-credit-amt{font-weight:800;font-size:18px;color:#e53935}

        .pm-section{font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;margin:12px 2px 4px;letter-spacing:.5px}
        .pm-field{display:flex;align-items:center;justify-content:space-between;gap:10px;background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 12px}
        .pm-field .pm-label{flex:0 0 38%}
      `}</style>

      <div>
        {/* <Segmented ... /> kept commented as in original */}

        {/* ---- Total payable ---- */}
        <div className="pm-total">
          <div>
            <div className="pm-total-l">Total Payable</div>
            <div className="pm-total-v">₹ {Number(totalNetAmt || 0).toFixed(2)}</div>
          </div>
          <div className="pm-mode">
            {switchCredit === "Cash" ? cashValue : creditCashValue}
          </div>
        </div>

        {switchCredit === "Cash" && (
          <div className="pm-list">
            {/* CASH */}
            <div
              className={`pm-row ${cashValue === "CASH" ? "active" : ""}`}
              onClick={() => handleChange("CASH")}
            >
              <span className="pm-ico" style={{ background: "#e8f5e9" }}>
                <CurrencyRupeeIcon style={{ fontSize: "18px", color: "#2e7d32" }} />
              </span>
              <span className="pm-label">
                <Checkbox
                  checked={cashValue === "CASH"}
                  disabled={selectionLocked}
                  onChange={() => handleChange("CASH")}
                >
                  {" "}
                  CASH
                </Checkbox>
              </span>
              <span className="pm-val" onClick={() => handleChange("CASH")}>
                <Input
                  placeholder="Enter Cash Amount"
                  className="pm-input"
                  disabled
                  value={
                    cashAmt
                      ? cashAmt
                      : totalNetAmt - cardAmt - upiAmt - onlineAmt - creditAmt
                  }
                />
              </span>
            </div>

            {/* CARD */}
            <div
              className={`pm-row ${cashValue === "CARD" ? "active" : ""}`}
              onClick={() => handleChange("CARD")}
            >
              <span className="pm-ico" style={{ background: "#fdecea" }}>
                <CreditCardIcon style={{ fontSize: "18px", color: "#e53935" }} />
              </span>
              <span className="pm-label">
                <Checkbox
                  checked={cashValue === "CARD"}
                  disabled={selectionLocked}
                  onChange={() => handleChange("CARD")}
                >
                  {" "}
                  CARD
                </Checkbox>
              </span>
              <span className="pm-val" onClick={() => handleChange("CARD")}>
                <Input
                  placeholder="Enter Card Amount"
                  ref={cardRef}
                  className="pm-input"
                  value={cardAmt}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    // if (value.length <= 10) {
                    // setCardAmt(value);
                    handleLimitedInput(e, setCardAmt);
                    setOnlineAmt(0);
                    setUpiAmt(0);
                    setCreditAmt(0);
                    // }
                  }}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                />
              </span>
            </div>

            {/* UPI */}
            <div
              className={`pm-row ${cashValue === "UPI" ? "active" : ""}`}
              onClick={() => handleChange("UPI")}
            >
              <span className="pm-ico" style={{ background: "#e8f0fe" }}>
                <DocumentScannerIcon style={{ fontSize: "18px", color: "#1a56db" }} />
              </span>
              <span className="pm-label">
                <Checkbox
                  checked={cashValue === "UPI"}
                  disabled={selectionLocked}
                  onChange={() => handleChange("UPI")}
                >
                  {" "}
                  UPI
                </Checkbox>
              </span>
              <span className="pm-val" onClick={() => handleChange("UPI")}>
                <Input
                  placeholder="Enter UPI Amount"
                  ref={upiRef}
                  className="pm-input"
                  value={upiAmt}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    // if (value.length <= 10) {
                    // setUpiAmt(value);
                    handleLimitedInput(e, setUpiAmt);
                    setCardAmt(0);
                    setOnlineAmt(0);
                    setCreditAmt(0);
                    // }
                  }}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                />
              </span>
            </div>

            {/* ONLINE */}
            <div
              className={`pm-row ${cashValue === "ONLINE" ? "active" : ""}`}
              onClick={() => handleChange("ONLINE")}
            >
              <span className="pm-ico" style={{ background: "#e0f7f4" }}>
                <BookOnlineIcon style={{ fontSize: "18px", color: "#00897b" }} />
              </span>
              <span className="pm-label">
                <Checkbox
                  checked={cashValue === "ONLINE"}
                  disabled={selectionLocked}
                  onChange={() => handleChange("ONLINE")}
                >
                  {" "}
                  ONLINE
                </Checkbox>
              </span>
              <span className="pm-val" onClick={() => handleChange("ONLINE")}>
                <Input
                  placeholder="Enter Online Amount"
                  ref={onlineRef}
                  className="pm-input"
                  value={onlineAmt}
                  onChange={(e) => {
                    // const value = e.target.value.replace(/\D/g, "");
                    // if (value.length <= 10) {
                    // setOnlineAmt(value);
                    handleLimitedInput(e, setOnlineAmt);
                    setCardAmt(0);
                    setUpiAmt(0);
                    setCreditAmt(0);
                    // }
                  }}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                />
              </span>
            </div>

            {/* CREDIT */}
            <div
              className={`pm-row ${cashValue === "CREDIT" ? "active" : ""}`}
              onClick={() => handleChange("CREDIT")}
            >
              <span className="pm-ico" style={{ background: "#fff3e0" }}>
                <CreditScoreIcon style={{ fontSize: "18px", color: "#ef6c00" }} />
              </span>
              <span className="pm-label">
                <Checkbox
                  checked={cashValue === "CREDIT"}
                  disabled={selectionLocked}
                  onChange={() => handleChange("CREDIT")}
                >
                  {" "}
                  CREDIT
                </Checkbox>
              </span>
              <span className="pm-val" onClick={() => handleChange("CREDIT")}>
                <Input
                  placeholder="Enter Credit Amount"
                  ref={creditRef}
                  className="pm-input"
                  value={creditAmt}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    // if (value.length <= 10) {
                    // setCreditAmt(value);
                    handleLimitedInput(e, setCreditAmt);
                    setCardAmt(0);
                    setUpiAmt(0);
                    setOnlineAmt(0);
                    // }
                  }}
                  onFocus={(e) => {
                    e.target.select();
                  }}
                />
              </span>
            </div>
          </div>
        )}

        {switchCredit === "Credit" && (
          <>
            <div className="pm-list">
              {/* CREDIT summary row */}
              <div
                className={`pm-row ${creditCashValue === "CREDIT" ? "active" : ""}`}
                onClick={() => handleCreditChange("CREDIT")}
              >
                <span className="pm-ico" style={{ background: "#fff3e0" }}>
                  <CreditScoreIcon style={{ fontSize: "18px", color: "#ef6c00" }} />
                </span>
                <span className="pm-label">
                  <Checkbox
                    checked={creditCashValue === "CREDIT"}
                    disabled={selectionCreditLocked}
                    onChange={() => handleCreditChange("CREDIT")}
                  >
                    {" "}
                    CREDIT
                  </Checkbox>
                </span>
                <span
                  className="pm-credit-amt"
                  onClick={() => handleCreditChange("CREDIT")}
                >
                  {totalNetAmt -
                    creditCashAmt -
                    creditCardAmt -
                    creditOnlineAmt -
                    creditUpiAmt}
                </span>
              </div>

              <div className="pm-field">
                <span className="pm-label">Contact No</span>
                <Input
                  placeholder="Enter Customer No"
                  className="pm-input-wide"
                />
              </div>
              <div className="pm-field">
                <span className="pm-label">Name</span>
                <Select
                  allowClear
                  showSearch={false} // Disable manual typing
                  style={{ width: "100%" }}
                ></Select>
              </div>
              <div className="pm-field">
                <span className="pm-label">Balance Amt</span>
                <Input
                  placeholder="Enter Customer No"
                  className="pm-input-wide"
                />
              </div>
            </div>

            <div className="pm-section">Paid now</div>
            <div className="pm-list">
              {/* CASH */}
              <div
                className={`pm-row ${creditCashValue === "CASH" ? "active" : ""}`}
                onClick={() => handleCreditChange("CASH")}
              >
                <span className="pm-ico" style={{ background: "#e8f5e9" }}>
                  <CurrencyRupeeIcon style={{ fontSize: "18px", color: "#2e7d32" }} />
                </span>
                <span className="pm-label">
                  <Checkbox
                    checked={creditCashValue === "CASH"}
                    disabled={selectionCreditLocked}
                    onChange={() => handleCreditChange("CASH")}
                  >
                    {" "}
                    CASH
                  </Checkbox>
                </span>
                <span
                  className="pm-val"
                  onClick={() => handleCreditChange("CASH")}
                >
                  <Input
                    placeholder="Enter Cash Amount"
                    className="pm-input"
                    value={creditCashAmt}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setCreditCashAmt(value);
                        setCreditCardAmt(0);
                        setCreditUpiAmt(0);
                        setCreditOnlineAmt(0);
                      }
                    }}
                  />
                </span>
              </div>

              {/* CARD */}
              <div
                className={`pm-row ${creditCashValue === "CARD" ? "active" : ""}`}
                onClick={() => handleCreditChange("CARD")}
              >
                <span className="pm-ico" style={{ background: "#fdecea" }}>
                  <CreditCardIcon style={{ fontSize: "18px", color: "#e53935" }} />
                </span>
                <span className="pm-label">
                  <Checkbox
                    checked={creditCashValue === "CARD"}
                    disabled={selectionCreditLocked}
                    onChange={() => handleCreditChange("CARD")}
                  >
                    {" "}
                    CARD
                  </Checkbox>
                </span>
                <span
                  className="pm-val"
                  onClick={() => handleCreditChange("CARD")}
                >
                  <Input
                    placeholder="Enter Card Amount"
                    className="pm-input"
                    value={creditCardAmt}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setCreditCardAmt(value);
                        setCreditUpiAmt(0);
                        setCreditOnlineAmt(0);
                        setCreditCashAmt(0);
                      }
                    }}
                  />
                </span>
              </div>

              {/* UPI */}
              <div
                className={`pm-row ${creditCashValue === "UPI" ? "active" : ""}`}
                onClick={() => handleCreditChange("UPI")}
              >
                <span className="pm-ico" style={{ background: "#e8f0fe" }}>
                  <DocumentScannerIcon style={{ fontSize: "18px", color: "#1a56db" }} />
                </span>
                <span className="pm-label">
                  <Checkbox
                    checked={creditCashValue === "UPI"}
                    disabled={selectionCreditLocked}
                    onChange={() => handleCreditChange("UPI")}
                  >
                    {" "}
                    UPI
                  </Checkbox>
                </span>
                <span
                  className="pm-val"
                  onClick={() => handleCreditChange("UPI")}
                >
                  <Input
                    placeholder="Enter UPI Amount"
                    className="pm-input"
                    value={creditUpiAmt}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setCreditUpiAmt(value);
                        setCreditOnlineAmt(0);
                        setCreditCardAmt(0);
                        setCreditCashAmt(0);
                      }
                    }}
                  />
                </span>
              </div>

              {/* ONLINE */}
              <div
                className={`pm-row ${creditCashValue === "ONLINE" ? "active" : ""}`}
                onClick={() => handleCreditChange("ONLINE")}
              >
                <span className="pm-ico" style={{ background: "#e0f7f4" }}>
                  <BookOnlineIcon style={{ fontSize: "18px", color: "#00897b" }} />
                </span>
                <span className="pm-label">
                  <Checkbox
                    checked={creditCashValue === "ONLINE"}
                    disabled={selectionCreditLocked}
                    onChange={() => handleCreditChange("ONLINE")}
                  >
                    {" "}
                    ONLINE
                  </Checkbox>
                </span>
                <span
                  className="pm-val"
                  onClick={() => handleCreditChange("ONLINE")}
                >
                  <Input
                    placeholder="Enter Online Amount"
                    className="pm-input"
                    value={creditOnlineAmt}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        setCreditOnlineAmt(value);
                        setCreditCardAmt(0);
                        setCreditUpiAmt(0);
                        setCreditCashAmt(0);
                      }
                    }}
                  />
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default CashMethod;